'use client';

import { Toaster } from '@/components/ui';
import ThemeConfig from '@/styles/theme/theme';
import { ChakraProvider, Theme } from '@chakra-ui/react';
import React from 'react';

function ChakraThemeProvider({ children }: { children: React.ReactNode }) {
   return (
      <ChakraProvider value={ThemeConfig}>
         <Theme minH="100vh" appearance="dark">
            <main>{children}</main>
            <Toaster />
         </Theme>
      </ChakraProvider>
   );
}

export default ChakraThemeProvider;
